import { Middleware } from "redux";
import { AppState } from "store";
import { BroadcastChannel } from "broadcast-channel";

import { ReduxConstants } from "./constants";

const RECEIVED_ACTION = "RECEIVED_ACTION";

const syncForDifferentCompanies = new Set([
  ReduxConstants.AuthActions.LOGIN_SUCCESS,
  ReduxConstants.AuthActions.SET_FETCHING_REFRESH_TOKEN,
  ReduxConstants.AuthActions.LOAD_COMPANIES,
  ReduxConstants.AuthActions.SET_PROFILE_NAME,
  ReduxConstants.CommonActions.TOGGLE_LANGUAGE,
  ReduxConstants.CommonActions.PROFILESETTINGS_LANGUAGE,
]);

const skipSyncActions = new Set([
  ReduxConstants.AuthActions.SET_SELECTED_COMPANY,
  ReduxConstants.AuthActions.SET_SELECTED_COMPANY_ID,
  ReduxConstants.AuthActions.LOGOUT,
  ReduxConstants.UtilActions.DISPLAY_DIALOG,
  ReduxConstants.UtilActions.CLOSE_DIALOG,
  ...Object.keys(ReduxConstants.ListActions),
  ReduxConstants.TodoActions.SET_LIST_NAVIGATION,
  ReduxConstants.TodoActions.LOAD_CURRENT_NAVIGATION_ITEMS,
  ReduxConstants.TodoActions.SET_CURRENT_INDEX,
  ReduxConstants.TodoActions.SET_TODO_DRAWER_STATE,
  ReduxConstants.TodoActions.EMPTY_TODOS,
  ReduxConstants.TodoActions.EMPTY_TODOS_SUMMARY,
]);

const syncReduxActions: Middleware<{}, AppState> = ({ dispatch, getState }) => {
  let channel: BroadcastChannel;
  try {
    channel = new BroadcastChannel("wint_app_redux_actions");
  } catch {
    return (next) => (action) => next(action);
  }

  channel.addEventListener("message", (msg) => {
    const currentCompany = getState().auth.selectedCompany.id;
    const { companyId, action } = msg;

    if (companyId === currentCompany || syncForDifferentCompanies.has(action.type)) {
      dispatch({
        type: RECEIVED_ACTION,
        payload: action,
      });
    }
  });

  return (next) => (action) => {
    if (action.type === RECEIVED_ACTION) {
      next(action.payload);
    } else if (action.type === ReduxConstants.UtilActions.AS_COMPANY) {
      syncAction(action.payload.companyId, action.payload.action);
      next(action.payload.action);
    } else {
      const companyId = getState().auth.selectedCompanyId;
      syncAction(companyId ?? 0, action);
      next(action);
    }
  };

  function syncAction(companyId: number, action: { type: string; payload?: any }) {
    if (skipSyncActions.has(action.type)) return;
    // The company gate on the receiving side is not enough on its own: the wizard
    // runs in the same SPA as the logged-in app, so a tab that still holds a
    // selected company stamps that id on the action and a logged-in tab on the
    // same company would accept it.
    if (action.type.startsWith(ReduxConstants.OnboardingActions.ONBOARDING_ACTION_PREFIX)) return;
    channel.postMessage({
      companyId,
      action,
    });
  }
};

export default syncReduxActions;
